/**
 * The element showing a Characteristic: its own wrapper, or the widget of a
 * combining custom renderer that serves it (`data-configento-combined`).
 */
export function findCharacteristicElement(characteristicId: number, root: ParentNode = document): Element | null {
    return root.querySelector(`[data-configento-char-id="${characteristicId}"]`)
        ?? root.querySelector(`[data-configento-combined~="${characteristicId}"]`);
}
